/**
 * RESPONSIBILITY: the words around the home page's latest-sermon panel.
 *
 * The sermon shown is the newest row of the one sermons list, so nothing here can go
 * out of step with it.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Text, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.HomeSermon, label: 'Home - Latest sermon band' })
export class HomeSermonSection {
  @Text({
    label: 'Title', maxLength: 120, default: 'Latest message',
    description: 'The line above the sermon. The sermon itself is the newest in the list.',
  })
  heading!: string;
  @Text({ label: 'Button text', maxLength: 120, default: 'All sermons' }) linkLabel!: string;
  @Link({ label: 'Button link', default: '#sermons', description: LINK_HINT }) linkHref!: string;
}
